import { render, staticRenderFns } from "./MyCoupons.vue?vue&type=template&id=1a882ba1&scoped=true"
import script from "./MyCoupons.vue?vue&type=script&lang=js"
export * from "./MyCoupons.vue?vue&type=script&lang=js"
import style0 from "./MyCoupons.vue?vue&type=style&index=0&id=1a882ba1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a882ba1",
  null
  
)

export default component.exports